let mobileMenuLoaded = false

class MobileMenu extends window.BAO.CustomElement() {
  connectedCallback () {
    if (mobileMenuLoaded) return

    window.BAO.sectionRenderer
      .fetch('header', `${window.Shopify.routes.root}?view=mobile-menu`)
      .then((res) => {
        mobileMenuLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
        const myself = newDOM.querySelector('mobile-menu')
        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }
}

if (!customElements.get('mobile-menu')) {
  customElements.define('mobile-menu', MobileMenu)
}
